import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { ugcAgeSuitabilityShape, libraryShape } from '@bibliocommons/bc-prop-types';
import { selectUgcSummary } from 'app/selectors/bibs/UgcSelector';
import { selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import { selectCurrentUserAgeSuitabilities } from 'app/selectors/ugc/AgeSuitabilitiesSelector';
import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';
import BibsActions from 'app/actions/BibsActions';
import AgeSuitability from './AgeSuitability';

export function AgeSuitabilityContainer(props) {
  return <AgeSuitability {...props} />;
}

AgeSuitabilityContainer.propTypes = {
  currentUserAgeSuitability: ugcAgeSuitabilityShape,
  summary: ImmutablePropTypes.map.isRequired,
  metadataId: PropTypes.string,
  bibsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  currentLibrary: libraryShape.isRequired
};

const mapStateToProps = state => {
  const metadataId = selectCatalogBib(state).get('metadataId');
  return {
    currentUserAgeSuitability: selectCurrentUserAgeSuitabilities(state).get(metadataId),
    summary: selectUgcSummary(state),
    currentLibrary: selectCurrentLibrary(state),
    metadataId
  };
};

const mapDispatchToProps = dispatch => ({
  bibsActions: bindActionCreators(BibsActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(AgeSuitabilityContainer);
